import IDriverLicenseVm from "../models/shared/IDriverLicenseVm"
import * as IDriverLicenseVmInstance from "../models/shared/IDriverLicenseVm"
import IAction from "../store/IAction"
import { ApplicationCardStatusType } from "../models/enums/ApplicationCardStatusType"
import { DriverLicenseCategoriesType } from "../models/flags/DriverLicenseCategoriesType"
import { Dispatch } from "redux"
import InitState from "../store/initState"

const UPDATE_DRIVER_LICENSE_CARD_STATUS = "BAT2/driverLicense/UPDATE_DRIVER_LICENSE_CARD_STATUS"
const UPDATE_DRIVER_LICENSE_IMAGE_BACK = "BAT2/driverLicense/UPDATE_DRIVER_LICENSE_IMAGE_BACK"
const UPDATE_DRIVER_LICENSE_IMAGE_BACK_FOR_RESUBMIT = "BAT2/driverLicense/UPDATE_DRIVER_LICENSE_IMAGE_BACK_FOR_RESUBMIT"
const UPDATE_DRIVER_LICENSE_IMAGE_FRONT = "BAT2/driverLicense/UPDATE_DRIVER_LICENSE_IMAGE_FRONT"
const UPDATE_DRIVER_LICENSE_IMAGE_FRONT_FOR_RESUBMIT = "BAT2/driverLicense/UPDATE_DRIVER_LICENSE_IMAGE_FRONT_FOR_RESUBMIT"
const UPDATE_DRIVER_LICENSE_ISSUE_DATE = "BAT2/driverLicense/UPDATE_DRIVER_LICENSE_ISSUE_DATE"
const UPDATE_DRIVER_LICENSE_NUMBER = "BAT2/driverLicense/UPDATE_DRIVER_LICENSE_NUMBER"
const UPDATE_IS_DRIVERS_LICENSE_FOREIGN = "BAT2/driverLicense/UPDATE_IS_DRIVERS_LICENSE_FOREIGN"
const UPDATE_CHOSEN_DRIVER_LICENSE_CATEGORIES = "BAT2/driverLicense/UPDATE_CHOSEN_DRIVER_LICENSE_CATEGORIES"
const UPDATE_DRIVER_LICENCE_HAS_VALID_LICENSE = "BAT2/driverLicense/UPDATE_DRIVER_LICENCE_HAS_VALID_LICENSE"

export default function driverLicenseReducer(state: IDriverLicenseVm = IDriverLicenseVmInstance.empty(), action: IAction): IDriverLicenseVm {
    if (state === null || state === undefined) {
        return state
    }
    switch (action.type) {
        case UPDATE_DRIVER_LICENSE_IMAGE_FRONT:
            return { ...state, base64FrontImage: action.payload, isDriverLicenseFrontImageModified: true }
        case UPDATE_DRIVER_LICENSE_IMAGE_FRONT_FOR_RESUBMIT:
            return { ...state, base64FrontImage: action.payload.value, cardStatus: action.payload.cardStatusType, isDriverLicenseFrontImageModified: true }
        case UPDATE_DRIVER_LICENSE_IMAGE_BACK:
            return { ...state, base64BackImage: action.payload, isDriverLicenseBackImageModified: true }
        case UPDATE_DRIVER_LICENSE_IMAGE_BACK_FOR_RESUBMIT:
            return { ...state, base64BackImage: action.payload.value, cardStatus: action.payload.cardStatusType, isDriverLicenseBackImageModified: true }
        case UPDATE_DRIVER_LICENSE_CARD_STATUS:
            return { ...state, cardStatus: action.payload }
        case UPDATE_DRIVER_LICENSE_NUMBER:
            return { ...state, number: action.payload }
        case UPDATE_DRIVER_LICENSE_ISSUE_DATE:
            return { ...state, issueDate: action.payload }
        case UPDATE_IS_DRIVERS_LICENSE_FOREIGN:
            return { ...state, isLicenseForeign: action.payload }
        case UPDATE_CHOSEN_DRIVER_LICENSE_CATEGORIES:
            return { ...state, chosenLicenseCategories: action.payload }
        case UPDATE_DRIVER_LICENCE_HAS_VALID_LICENSE:
            return { ...state, hasValidLicense: action.payload }
        default:
            return state
    }
}

export function updateDriverLicenseImageFront(value: string, applicationId: string) {
    return { type: UPDATE_DRIVER_LICENSE_IMAGE_FRONT, payload: value, id: applicationId }
}
export function updateDriverLicenseImageFrontForResubmit(value: string, cardStatusType: ApplicationCardStatusType, applicationId: string, ) {
    return { type: UPDATE_DRIVER_LICENSE_IMAGE_FRONT_FOR_RESUBMIT, payload: { value, cardStatusType }, id: applicationId }
}
export function updateDriverLicenseImageBack(value: string, applicationId: string, ) {
    return { type: UPDATE_DRIVER_LICENSE_IMAGE_BACK, payload: value, id: applicationId }
}
export function updateDriverLicenseImageBackForResubmit(value: string, cardStatusType: ApplicationCardStatusType, applicationId: string, ) {
    return { type: UPDATE_DRIVER_LICENSE_IMAGE_BACK_FOR_RESUBMIT, payload: { value, cardStatusType }, id: applicationId }
}
export function updateDriversLicenseCardStatus(value: ApplicationCardStatusType, applicationId: string) {
    return { type: UPDATE_DRIVER_LICENSE_CARD_STATUS, payload: value, id: applicationId }
}
export function updateIsDriversLicenseForeign(value: boolean, applicationId: string) {
    return async (dispatch: Dispatch<any>, getState: () => InitState) => {
        // If IsDriversLicenseForeign is false, we remove all non-numeric-characters from the driver license number
        // and takes only the first 8 digits.
        if (value === false) {
            const driverLicenseNumber = getState().applications.filter(a =>
                a.id === applicationId)[0].driverLicense.number
                .replace(/\D/g, "")
                .substr(0, 8)

            dispatch({ type: UPDATE_DRIVER_LICENSE_NUMBER, payload: driverLicenseNumber, id: applicationId })
        }
        dispatch({ type: UPDATE_IS_DRIVERS_LICENSE_FOREIGN, payload: value, id: applicationId })
    }
}
export function updateDriverLicenseNumber(value: string, applicationId: string) {
    return { type: UPDATE_DRIVER_LICENSE_NUMBER, payload: value, id: applicationId }
}
export function updateDriverLicenseIssueDate(value: string, applicationId: string) {
    return { type: UPDATE_DRIVER_LICENSE_ISSUE_DATE, payload: value, id: applicationId }
}
export function updateChosenDriverLicenseCategories(value: DriverLicenseCategoriesType, applicationId: string) {
    return { type: UPDATE_CHOSEN_DRIVER_LICENSE_CATEGORIES, payload: value, id: applicationId }
}
export function updateHasValidDriverLicense(value: boolean, applicationId: string) {
    return { type: UPDATE_DRIVER_LICENCE_HAS_VALID_LICENSE, payload: value, id: applicationId }
}